export default __webpack_public_path__ + "file/Fiche-FR-Produit-Puroak-Mini-Staves.asset.d150daee.pdf";